export interface CountryOfPassportDataWithFlag {
  value: string;
  label: string;
  key: string;
  icon: React.ReactNode;
}

export interface CountryOfPassport {
  name: string;
  id: number;
  code2A: string;
  code3A: string;
  phoneId: string;
  flag: string;
}
export const defaultCountryList: CountryOfPassport[] = [
  {
    id: 106,
    name: "ไทย",
    code2A: "TH",
    code3A: "THA",
    phoneId: "66",
    flag: "🇹🇭",
  },
];

export const defaultCountryOfPassport: RequestGetCountryOfPassportInterface = {
  countryOfPassport: [
    {
      id: 106,
      name: "ไทย",
      code2A: "TH",
      code3A: "THA",
      phoneId: "66",
      flag: "🇹🇭",
    },
  ],
  total: 1,
};
export class RequestGetCountryOfPassportInterface {
  countryOfPassport: CountryOfPassport[];

  localCountry?: CountryOfPassport;

  total: number;

  constructor(
    data: RequestGetCountryOfPassportInterface = defaultCountryOfPassport,
  ) {
    this.total = data.total || 0;
    this.countryOfPassport = data.countryOfPassport || [];
  }
}
